import { render, staticRenderFns } from "./ManagePermissions.html?vue&type=template&id=5960709b&external"
import script from "./ManagePermissions.vue?vue&type=script&lang=js"
export * from "./ManagePermissions.vue?vue&type=script&lang=js"
import style0 from "./ManagePermissions.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports